import { useLoading } from "../../../../context/loadingContext";
import VestelSpinner from "../../../atoms/images/VestelSpinner";

const Spinner = () => {
  const { loading } = useLoading();

  if (!loading) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/15">
      <VestelSpinner />
    </div>
  );
};

export default Spinner;
